import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "revico-community-talk-talkroom-post" }
const _hoisted_2 = {
  key: 1,
  class: "revico-community-talk-talkroom-post--contents-error-message"
}
const _hoisted_3 = { class: "revico-community-talk-talkroom-post--postbutton-wrapper" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "revico-community-talk-talkroom-post" }
const _hoisted_6 = { class: "revico-community-talk-talkroom-post-complete--note" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "revico-community-talk-talkroom-post-complete--note" }, [
  /*#__PURE__*/_createTextVNode("※続けて投稿したい場合は"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("画面を更新してください。")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return ($setup.isFormVisible)
    ? (_openBlock(), _createBlock($setup["ApiPostLoadMaster"], {
        key: 0,
        status: $setup.status
      }, {
        beforeRequest: _withCtx(() => [
          _createElementVNode("section", _hoisted_1, [
            _createCommentVNode(" EC会員のみ可能な投稿許可の場合、ログインしてなければ訴求文言表示 "),
            (!$setup.isPostable)
              ? (_openBlock(), _createBlock($setup["RequireLogin"], { key: 0 }))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" 投稿フォーム "),
            _createCommentVNode(" 内容 "),
            _createVNode($setup["CustomLabel"], {
              class: "revico-community-talk-post-contents--label",
              text: "内容(必須)",
              disabled: !$setup.isPostable
            }, null, 8 /* PROPS */, ["disabled"]),
            _createVNode($setup["CustomTextarea"], {
              modelValue: $setup.contents,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ($setup.contents = $event)),
                _cache[1] || (_cache[1] = ($event: any) => ($setup.onChangeContents()))
              ],
              name: "contents",
              customClass: "revico-community-talk-talkroom-post--contents",
              "api-validation-error-view-model": $setup.apiValidationErrorViewModel,
              maxlength: 10000,
              disabled: !$setup.isPostable,
              placeholder: $props.wordSettings.talkRoomPostAreaDescription,
              rows: 5,
              "show-required-error": $setup.isContentsEmpty,
              label: "内容"
            }, null, 8 /* PROPS */, ["modelValue", "api-validation-error-view-model", "disabled", "placeholder", "show-required-error"]),
            ($setup.isOverContentsMaxLength)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($setup.AppConst.TALKROOM_CONTENTS_MAX_LENGTH) + "文字以下で投稿してください。", 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" 画像・動画投稿 "),
            _createVNode($setup["PostMedia"], {
              "community-talk-store-key": $props.communityTalkStoreKey,
              disabled: !$setup.isPostable,
              "post-type": "TalkRoom",
              "init-post-media-view-models": $setup.communityTalkStore.getTalkRoomPostMedia(),
              onOnSuccessUploadMedias: $setup.onSucessUploadMedias,
              onOnResetMedias: $setup.onResetMedias,
              onOnStartPostProcess: $setup.onStartMediaPostProcess,
              onOnEndPostProcess: $setup.onEndMediaPostProcess
            }, null, 8 /* PROPS */, ["community-talk-store-key", "disabled", "init-post-media-view-models"]),
            _createCommentVNode(" ニックネーム "),
            _createVNode($setup["PostNickName"], {
              "community-talk-store-key": $props.communityTalkStoreKey,
              "post-type": "TalkRoom",
              disabled: !$setup.isPostable,
              "api-validation-error-view-model": $setup.apiValidationErrorViewModel,
              "show-required-error": $setup.isNickNameEmpty
            }, null, 8 /* PROPS */, ["community-talk-store-key", "disabled", "api-validation-error-view-model", "show-required-error"]),
            _createCommentVNode(" プロフィール画像 "),
            _createVNode($setup["PostProfilePicture"], {
              "community-talk-store-key": $props.communityTalkStoreKey,
              disabled: !$setup.isPostable,
              "api-validation-error-view-model": $setup.apiValidationErrorViewModel,
              "post-type": "TalkRoom"
            }, null, 8 /* PROPS */, ["community-talk-store-key", "disabled", "api-validation-error-view-model"]),
            _createCommentVNode(" 投稿者プロフィール "),
            _createVNode($setup["PostReviewerAttribute"], {
              "community-talk-store-key": $props.communityTalkStoreKey,
              disabled: !$setup.isPostable,
              "api-validation-error-view-model": $setup.apiValidationErrorViewModel
            }, null, 8 /* PROPS */, ["community-talk-store-key", "disabled", "api-validation-error-view-model"]),
            _createCommentVNode(" 投稿ボタン "),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                type: "button",
                disabled: !$setup.isEnabledPostButton(),
                onClick: $setup.post,
                class: "revico-community-talk-talkroom-post--postbutton"
              }, [
                _createTextVNode(_toDisplayString($props.wordSettings.talkRoomPostButtonDisplayName), 1 /* TEXT */),
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-paper-plane" })
              ], 8 /* PROPS */, _hoisted_4)
            ])
          ])
        ]),
        afterApiSuccess: _withCtx(() => [
          _createElementVNode("section", _hoisted_5, [
            _createVNode($setup["PostComplete"], null, {
              contents: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.wordSettings.talkRoomPostCompleteText), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createElementVNode("p", _hoisted_6, _toDisplayString($props.wordSettings.reviewPostedAnnotationText), 1 /* TEXT */),
            _createVNode($setup["TalkRoomPostNoticeMail"], {
              communityTalkStoreKey: $props.communityTalkStoreKey,
              talkRoomId: $setup.postTalkRoomId
            }, null, 8 /* PROPS */, ["communityTalkStoreKey", "talkRoomId"]),
            _hoisted_7
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["status"]))
    : _createCommentVNode("v-if", true)
}